import { useEffect, useState } from 'react';

export const useAutoDisposableTooltipState = (
  defaultText = '',
  delay = 1000
) => {
  const [isOpened, setTooltipIsOpened] = useState(false);
  const [tooltipText, setTooltipText] = useState(defaultText);

  const triggerTooltip = (tooltipText: string) => {
    if (isOpened) return;

    setTooltipIsOpened(true);
    setTooltipText(tooltipText);
  };

  const forceHide = () => setTooltipIsOpened(false);

  useEffect(() => {
    if (isOpened) {
      setTimeout(() => {
        setTooltipIsOpened(false);
        setTooltipText(defaultText);
      }, delay);
    }
  }, [isOpened]);

  return {
    isOpened,
    triggerTooltip,
    forceHide,
    tooltipText,
  };
};
